<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <textarea [(ngModel)]="value" matInput=""></textarea>
</mat-form-field>
